import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class EmlakBorcKontrolAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "EmlakBorcKontrol";
        super(baseUrl);
    }
    getEmlakBorcKontrol(SqId: number, Durum: number) {
        var request = new EmlakBorcKontrolRequest(SqId, Durum);

        return this.post("", request, false);
    }
}
export default new EmlakBorcKontrolAPI();
class EmlakBorcKontrolRequest {
    public sqId: number;
    public durum: number;

    constructor(sqId: number, durum: number) {

        this.sqId = sqId;
        this.durum = durum;

    }
}
export { EmlakBorcKontrolRequest };